import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../NavLogo.png';
import arrowIcon from '../arrow.png';
import newsIcon from '../news.png';
import locationIcon from '../location.png';
import callIcon from '../call.png';
import instaIcon from '../insta.png';
import linkedInIcon from '../linkedIn.png';
import twitterIcon from '../twitter.png';
import facebookIcon from '../facebook.png';
import picsartIcon from '../picsart.png';
import youtubeIcon from '../yoytube.png';
import placeholderIcon from '../placeholder.png';
import bottomImage from '../bottom.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="brand-logo">
                <img src={logo} alt="Sri Veda Gurukulam" />
                
              </div>
              <p className="brand-description">
                Preserving Vedic wisdom through the Guru-Shishya 
                tradition, rooted in discipline and Dharma.
              </p>
              <div className="social-icons">
                <a href="#" className="social-link">
                  <img src={instaIcon} alt="Instagram" />
                </a>
                <a href="#" className="social-link">
                  <img src={picsartIcon} alt="Picsart" />
                </a>
                <a href="#" className="social-link">
                  <img src={twitterIcon} alt="Twitter" />
                </a>
                <a href="#" className="social-link">
                  <img src={facebookIcon} alt="Facebook" />
                </a>
                <a href="#" className="social-link">
                  <img src={linkedInIcon} alt="LinkedIn" />
                </a>
                <a href="#" className="social-link">
                  <img src={youtubeIcon} alt="YouTube" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-links">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <Link to="/about" className="footer-nav-link">
                    <img src={arrowIcon} alt="Arrow" className="link-arrow" />
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/events" className="footer-nav-link">
                    <img src={arrowIcon} alt="Arrow" className="link-arrow" />
                    Events
                  </Link>
                </li>
                <li>
                  <Link to="/veda-gurukulam" className="footer-nav-link">
                    <img src={arrowIcon} alt="Arrow" className="link-arrow" />
                    Veda Gurukulam
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="footer-nav-link">
                    <img src={arrowIcon} alt="Arrow" className="link-arrow" />
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="footer-nav-link">
                    <img src={arrowIcon} alt="Arrow" className="link-arrow" />
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Location */}
            <div className="footer-location">
              <h3>Location</h3>
              <div className="location-item">
                <img src={locationIcon} alt="Address" className="location-icon" />
                <div className="location-text">
                  <span className="location-label">Address</span>
                  <p>Agni Puram, #4-17/2,<br />
                     Khanapur, C.B.I.T,<br />
                     Gandipet,<br />
                     Hyderabad - 500075</p>
                </div>
              </div>
              <div className="location-item">
                <img src={callIcon} alt="Phone" className="location-icon" />
                <div className="location-text">
                  <span className="location-label">Phone</span>
                  <p>+91 94932 90510</p>
                </div>
              </div>
            </div>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <h3>Newsletter Signup</h3>
              <div className="newsletter-form">
                <div className="input-container">
                  <img src={placeholderIcon} alt="Email" className="input-icon" />
                  <input type="email"  />
                  <button type="submit" className="submit-btn">
                    <img src={arrowIcon} alt="Submit" />
                  </button>
                </div>
              </div>
              <p className="newsletter-text">
                Get the latest updates and offers for business services yearly.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="bottom-image">
          <img src={bottomImage} alt="Sri Veda Gurukulam" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;